<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
           <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item prop="attendaceGroupId" label="考勤绑定">
                    <el-select v-model="form.attendaceGroupId" placeholder="请选择" style="width:300px;">
                        <el-option
                            v-for="item in attendaceGroups"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item   prop="cycleType" label="生成周期">
                    <el-select v-model="form.cycleType" clearable @change="changeTaskTitle" placeholder="请选择" style="width:300px;">
                        <el-option
                            v-for="item in cycleTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="" label="任务关联模块">
                    <div border style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width:300px;">
                        <el-checkbox v-for="module in moduleArr" :key="module.id"  v-model="form.taskModule" :label="module.id" border size="medium" style="margin:5px;">
                            {{module.moduleTitle}}
                        </el-checkbox>
                    </div>
                </el-form-item>
           
                <el-form-item  prop="" label="任务接收者">
                    <el-button @click="getMoreUser()">{{form.receiveTaskUsersLabel}}</el-button>
                </el-form-item>

                <el-form-item  prop="executeCount" label="评价次数">
                    <el-input v-model="form.executeCount" @input="changeTaskTitle" maxlength="5" style="width:300px;" type="number"></el-input>
                </el-form-item>

                <el-form-item  prop="" label="任务生成标题">
                    <div v-if="form.taskTitle != null && form.taskTitle!=''" style="color:red">
                        {{form.taskTitle}}
                    </div>
                    <div v-else style="color:red">
                        无
                    </div>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import { MessageBox } from 'element-ui';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        name:"TaskConfig",
        data(){
            return{
                visible:false,
                transferVisible:false,
                form:{
                    deptId:"",
                    attendaceGroupId:"",
                    cycleType:"",
                    taskModule:[],
                    receiveTaskUsers:[],
                    receiveTaskUsersLabel:"",
                    executeCount:3,
                    taskTitle:""
                },
                depts:[],
                cycleTypes:[{
                    value: 1,
                    label: '每月'
                }, {
                    value: 2,
                    label: '每周'
                }],
                attendaceGroups:[],
                moduleArr:[],
                rules: {
                    attendaceGroupId: [
                        { required: true, message: '请选择宿舍考勤绑定', trigger: 'blur' }
                    ],
                    cycleType: [
                        { required: true, message: '请选择生成周期', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.form.receiveTaskUsers=[];
                this.form.receiveTaskUsersLabel="请选择";
                this.form.taskTitle="";
                // 初始数据
                this.getAttendaceGroup();
                this.getTaskModule();
            },
            //获取考勤组
            getAttendaceGroup(){
                let url  = this.listAttendaceGroupDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.attendaceGroups = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取任务关联模块
            getTaskModule(){
                let url  = this.moduleConfigList2Url;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.moduleArr=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 生成任务标题
            changeTaskTitle(){
                 if(this.form.cycleType == 1){ // 每月
                    this.form.taskTitle="当月完成"+this.form.executeCount+"次#模块名称#任务";
                 }else if(this.form.cycleType == 2){ // 每周
                    this.form.taskTitle="本周完成"+this.form.executeCount+"次#模块名称#任务";
                 }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 验证任务关联模块不能为空
                        if(this.form.taskModule.length == 0){
                            this.$commonFn.showTip("请选择任务关联模块",3);
                            return;
                        }
                        // 验证任务接收者不能为空
                        if(this.form.receiveTaskUsers.length == 0){
                            this.$commonFn.showTip("任务接收者不能为空",3);
                            return;
                        }
                        
                        let url= this.myTaskConfigSavetUrl;
                        let data = {
                            deptId:this.form.deptId,
                            attendaceGroupId:this.form.attendaceGroupId,
                            cycleType:this.form.cycleType,
                            taskModule:this.form.taskModule.join(','),
                            receiveTaskUsers:this.form.receiveTaskUsers.join(','),
                            executeCount:this.form.executeCount,
                            taskTitle:this.form.taskTitle
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });

                    }
                });
            },
            getMoreUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    console.log("部门ID："+this.form.deptId);
                    this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                })
            },
            setUser(key,label){
                this.form.receiveTaskUsers = key;
                this.form.receiveTaskUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/task/Add.vue